import "./Footer.scss";

function Footer() {
  return (
    <footer className="footer">
      <p className="footer__text">© InStock Inc. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
